import { createLowlight } from 'lowlight'

import bash from 'highlight.js/lib/languages/bash'
import css from 'highlight.js/lib/languages/css'
import diff from 'highlight.js/lib/languages/diff'
import go from 'highlight.js/lib/languages/go'
import graphql from 'highlight.js/lib/languages/graphql'
import ini from 'highlight.js/lib/languages/ini'
import java from 'highlight.js/lib/languages/java'
import javascript from 'highlight.js/lib/languages/javascript'
import json from 'highlight.js/lib/languages/json'
import markdown from 'highlight.js/lib/languages/markdown'
import plaintext from 'highlight.js/lib/languages/plaintext'
import python from 'highlight.js/lib/languages/python'
import ruby from 'highlight.js/lib/languages/ruby'
import rust from 'highlight.js/lib/languages/rust'
import shell from 'highlight.js/lib/languages/shell'
import sql from 'highlight.js/lib/languages/sql'
import typescript from 'highlight.js/lib/languages/typescript'
import xml from 'highlight.js/lib/languages/xml'
import yaml from 'highlight.js/lib/languages/yaml'

// Single shared registry, lazily populated on first call. Keeps each editor
// instance cheap and avoids re-registering languages on every mount.
let lowlightInstance: ReturnType<typeof createLowlight> | null = null

export function getLowlight(): ReturnType<typeof createLowlight> {
  if (lowlightInstance) return lowlightInstance

  const instance = createLowlight()

  instance.register('bash', bash)
  instance.register('sh', shell)
  instance.register('css', css)
  instance.register('diff', diff)
  instance.register('go', go)
  instance.register('graphql', graphql)
  instance.register('ini', ini)
  instance.register('java', java)
  instance.register('javascript', javascript)
  instance.register('js', javascript)
  instance.register('jsx', javascript)
  instance.register('json', json)
  instance.register('markdown', markdown)
  instance.register('md', markdown)
  instance.register('plaintext', plaintext)
  instance.register('text', plaintext)
  instance.register('python', python)
  instance.register('py', python)
  instance.register('ruby', ruby)
  instance.register('rust', rust)
  instance.register('rs', rust)
  instance.register('sql', sql)
  instance.register('typescript', typescript)
  instance.register('ts', typescript)
  instance.register('tsx', typescript)
  instance.register('html', xml)
  instance.register('xml', xml)
  instance.register('yaml', yaml)
  instance.register('yml', yaml)

  lowlightInstance = instance
  return instance
}
